import React from 'react';
import styles from '../../../../styles/DashboardV2.module.css';

interface DashboardCardProps {
    title: string;
    action?: { label: string; onClick: () => void };
    loading?: boolean;
    children: React.ReactNode;
    className?: string;
}

const iconVariantMap: Record<string, string> = {
    blue:   styles.cardIconBlue,
    green:  styles.cardIconGreen,
    amber:  styles.cardIconAmber,
    red:    styles.cardIconRed,
    purple: styles.cardIconPurple,
};

const DashboardCard: React.FC<DashboardCardProps> = ({
    title,
    action,
    loading,
    children,
    className,
}) => {
    if (loading) {
        return (
            <div className={`${styles.skeletonCard} ${className ?? ''}`}>
                <div className={`${styles.skeleton} ${styles.skeletonLine}`} style={{ width: '40%' }} />
                <div className={`${styles.skeleton} ${styles.skeletonLine}`} style={{ width: '70%', height: '32px' }} />
                <div className={`${styles.skeleton} ${styles.skeletonLine}`} style={{ width: '55%' }} />
            </div>
        );
    }

    return (
        <div className={`${styles.card} ${className ?? ''}`}>
            <div className={styles.cardHeader}>
                <p className={styles.cardTitle}>{title}</p>
                {action && (
                    <button className={styles.cardAction} onClick={action.onClick}>
                        {action.label}
                    </button>
                )}
            </div>
            {children}
        </div>
    );
};

export default DashboardCard;
